"use strict";

exports.__esModule = true;
exports.default = void 0;
var _isSymbol = _interopRequireDefault(require("./isSymbol.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || (0, _isSymbol.default)(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
var _default = exports.default = toKey;